/** Inline in <head> to avoid theme flash (cookie -> data-theme before paint). */
export function themeInitScript(): string {
  return `(function(){try{var m=document.cookie.match(/VISERA_THEME=(dark|light)/);var t=m?m[1]:(matchMedia('(prefers-color-scheme: light)').matches?'light':'dark');document.documentElement.setAttribute('data-theme',t)}catch(e){document.documentElement.setAttribute('data-theme','dark')}})()`;
}
